/**
 * Calculate the holding month and year based on current date
 * Logic:
 * - If date < 10th of current month: use 2 months behind
 * - If date >= 10th: use previous month (1 month behind)
 * 
 * @returns {Object} { holdingMonth: string, holdingYear: string }
 */
export const getHoldingPeriod = () => {
  const now = new Date();
  const currentDay = now.getDate();
  const currentMonth = now.getMonth(); // 0-11
  const currentYear = now.getFullYear();

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  let monthsToSubtract = currentDay < 10 ? 2 : 1;
  
  // Calculate target month and year
  let targetMonth = currentMonth - monthsToSubtract;
  let targetYear = currentYear;

  // Handle year boundaries
  while (targetMonth < 0) {
    targetMonth += 12;
    targetYear -= 1;
  }

  return {
    holdingMonth: monthNames[targetMonth],
    holdingYear: targetYear.toString()
  };
};

/**
 * Standard month options used throughout the app
 */
export const monthOptions = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

/**
 * Standard year options used throughout the app
 */
export const yearOptions = ["2026", "2025", "2024", "2023"];

